export default __webpack_public_path__ + "static/media/eot2.8abff277.png";